type Constructor = new (...args: unknown[]) => unknown;
type ProtoWithConstructor = { constructor?: Constructor } | null;

/**
 * Checks if the value is of the specified type.
 */
export function checkValue(
    value: unknown,
    type: Constructor,
): void {
    const proto = Object.getPrototypeOf(value as object) as ProtoWithConstructor;

    if (!proto || proto.constructor !== type) {
        throw new Error(`Value '${String(value)}' must be of type ${type.name}`);
    }
}

/**
 * Handles errors that occur when a promise fails to resolve.
 */
export function handlePromiseError(error: unknown): never {
    const msg = error instanceof Error ? error.message : String(error);
    throw new Error(`Failed to resolve promise:\n${msg}`);
}
